import type { BrowserTarget } from "../lib/install";

/** Simple monochrome browser glyphs (currentColor), for install CTAs. */
export function BrowserIcon({
  browser,
  className = "w-4 h-4",
}: {
  browser: BrowserTarget;
  className?: string;
}) {
  if (browser === "firefox") {
    return (
      <svg
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`shrink-0 ${className}`}
        aria-hidden="true"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            d="M28.9905 10.7265C28.3816 9.2574 27.1473 7.67139 26.1784 7.17039C26.967 8.72015 27.4232 10.2746 27.5976 11.4344C27.5976 11.4344 27.5976 11.4426 27.6005 11.4578C26.0156 7.49777 23.3277 5.90065 21.1327 2.42407C21.0213 2.24869 20.9105 2.07331 20.802 1.88566C20.7407 1.77985 20.6911 1.68397 20.648 1.59336C20.557 1.41757 20.4867 1.23179 20.4386 1.03975C20.439 1.03063 20.4359 1.02169 20.4301 1.01467C20.4243 1.00765 20.4161 1.00305 20.4071 1.00175C20.3985 0.999416 20.3894 0.999416 20.3808 1.00175C20.3785 1.00281 20.3763 1.00419 20.3744 1.00584C20.3709 1.00584 20.3674 1.00994 20.3639 1.0111L20.3697 1.0035C16.8483 3.07063 15.6536 6.89446 15.544 8.80784C14.1368 8.90428 12.7913 9.42358 11.683 10.298C11.5672 10.1998 11.4461 10.1081 11.3202 10.0232C11.0008 8.9027 10.9873 7.71683 11.2811 6.58931C9.84091 7.24697 8.72095 8.28463 7.90664 9.20303H7.90023C7.34433 8.49742 7.38341 6.17015 7.41491 5.68435C7.40849 5.65395 7.00076 5.89656 6.94826 5.93339C6.45773 6.2841 5.9992 6.67771 5.57805 7.1096C5.0988 7.59655 4.66096 8.12276 4.26909 8.68274C3.36752 9.96323 2.72814 11.4101 2.3879 12.9398C2.38149 12.9702 2.37565 13.0017 2.36924 13.0327C2.34299 13.1561 2.24791 13.7751 2.23099 13.9096V13.9406C2.10704 14.5803 2.02984 15.2282 2 15.8791V15.951C2 23.7097 8.27646 30 16.0182 30C22.9521 30 28.7088 24.9549 29.8364 18.328C29.8597 18.1485 29.8789 17.9673 29.8999 17.786C30.1788 15.3763 29.869 12.8439 28.9905 10.7265ZM12.8327 21.7239C12.8981 21.7549 12.9599 21.7894 13.027 21.8197L13.0363 21.8256C12.9692 21.7929 12.901 21.759 12.8333 21.7239H12.8327ZM27.6017 11.4642V11.4508V11.466V11.4642Z"
            fill="url(#paint0_linear_87_7118)"
          ></path>{" "}
          <path
            d="M28.9907 10.7265C28.3818 9.25741 27.1475 7.67141 26.1786 7.17041C26.9672 8.72017 27.4234 10.2746 27.5978 11.4344V11.4631C28.9208 15.0572 28.1998 18.7121 27.1615 20.9452C25.555 24.4002 21.6661 27.9416 15.578 27.7692C9.00581 27.5821 3.21175 22.6885 2.1297 16.2842C1.93254 15.2735 2.1297 14.7608 2.22886 13.9406C2.10812 14.5725 2.06203 14.7555 2.00195 15.8791V15.951C2.00195 23.7098 8.27842 30 16.0202 30C22.954 30 28.7108 24.9549 29.8383 18.328C29.8616 18.1485 29.8809 17.9673 29.9019 17.7861C30.179 15.3764 29.8692 12.8439 28.9907 10.7265Z"
            fill="url(#paint1_radial_87_7118)"
          ></path>{" "}
          <path
            d="M28.9907 10.7265C28.3818 9.25741 27.1475 7.67141 26.1786 7.17041C26.9672 8.72017 27.4234 10.2746 27.5978 11.4344V11.4631C28.9208 15.0572 28.1998 18.7121 27.1615 20.9452C25.555 24.4002 21.6661 27.9416 15.578 27.7692C9.00581 27.5821 3.21175 22.6885 2.1297 16.2842C1.93254 15.2735 2.1297 14.7608 2.22886 13.9406C2.10812 14.5725 2.06203 14.7555 2.00195 15.8791V15.951C2.00195 23.7098 8.27842 30 16.0202 30C22.954 30 28.7108 24.9549 29.8383 18.328C29.8616 18.1485 29.8809 17.9673 29.9019 17.7861C30.179 15.3764 29.8692 12.8439 28.9907 10.7265Z"
            fill="url(#paint2_radial_87_7118)"
          ></path>{" "}
          <path
            d="M22.1776 12.3773C22.2085 12.3989 22.2359 12.4205 22.2651 12.4422C21.9133 11.8161 21.4749 11.243 20.9631 10.7398C16.6058 6.37292 19.821 1.27058 20.3629 1.01102L20.3687 1.00342C16.8473 3.07054 15.6526 6.89438 15.543 8.80776C15.7063 8.79665 15.869 8.78262 16.0353 8.78262C18.6631 8.78262 20.952 10.2312 22.1776 12.3773Z"
            fill="url(#paint3_radial_87_7118)"
          ></path>{" "}
          <path
            d="M16.0446 13.2499C16.0219 13.6006 14.7899 14.8049 14.3589 14.8049C10.3725 14.8049 9.72559 17.2216 9.72559 17.2216C9.90058 19.2572 11.3157 20.9332 13.0277 21.82C13.1059 21.8604 13.1846 21.8966 13.2611 21.9329C13.3981 21.9913 13.5358 22.0498 13.6729 22.1018C14.26 22.3094 14.8748 22.4276 15.4969 22.4526C22.4838 22.7811 23.8383 14.08 18.7955 11.5534C20.0864 11.3283 21.4269 11.8492 22.1753 12.3759C20.9503 10.2299 18.6608 8.78125 16.033 8.78125C15.8667 8.78125 15.704 8.79528 15.5406 8.80639C14.1345 8.90403 12.7903 9.4239 11.6832 10.2983C11.8973 10.4801 12.1388 10.7221 12.6468 11.2237C13.6 12.1661 16.0394 13.1359 16.0446 13.2499Z"
            fill="url(#paint4_radial_87_7118)"
          ></path>{" "}
          <path
            d="M16.0446 13.2499C16.0219 13.6006 14.7899 14.8049 14.3589 14.8049C10.3725 14.8049 9.72559 17.2216 9.72559 17.2216C9.90058 19.2572 11.3157 20.9332 13.0277 21.82C13.1059 21.8604 13.1846 21.8966 13.2611 21.9329C13.3981 21.9913 13.5358 22.0498 13.6729 22.1018C14.26 22.3094 14.8748 22.4276 15.4969 22.4526C22.4838 22.7811 23.8383 14.08 18.7955 11.5534C20.0864 11.3283 21.4269 11.8492 22.1753 12.3759C20.9503 10.2299 18.6608 8.78125 16.033 8.78125C15.8667 8.78125 15.704 8.79528 15.5406 8.80639C14.1345 8.90403 12.7903 9.4239 11.6832 10.2983C11.8973 10.4801 12.1388 10.7221 12.6468 11.2237C13.6 12.1661 16.0394 13.1359 16.0446 13.2499Z"
            fill="url(#paint5_radial_87_7118)"
          ></path>{" "}
          <path
            d="M11.0311 9.83093C11.1448 9.90459 11.2382 9.96656 11.3227 10.0233C11.0034 8.90275 10.9899 7.71688 11.2837 6.58936C9.84345 7.24702 8.72349 8.28468 7.90918 9.20308C7.97509 9.20132 10.0085 9.16449 11.0311 9.83093Z"
            fill="url(#paint6_radial_87_7118)"
          ></path>{" "}
          <path
            d="M2.1297 16.284C3.21175 22.6883 9.00581 27.5819 15.5827 27.769C21.6707 27.9414 25.5574 24.4 27.1661 20.945C28.2044 18.7113 28.9254 15.057 27.6025 11.4629V11.436C27.6025 11.4395 27.6025 11.4442 27.6054 11.4594C28.1024 14.7138 26.451 17.8665 23.8692 19.9986C23.8666 20.0045 23.8641 20.0106 23.8617 20.0167C18.8306 24.1223 14.0165 22.4936 13.0418 21.8289C12.9741 21.7962 12.9059 21.7623 12.8382 21.7272C9.9047 20.3242 8.69316 17.6438 8.95273 15.3469C6.47656 15.3469 5.63192 13.2529 5.63192 13.2529C5.63192 13.2529 7.85552 11.664 10.7861 13.046C13.5003 14.3262 16.0493 13.2535 16.0493 13.2529C16.0441 13.1389 13.6047 12.1662 12.6533 11.2267C12.1452 10.7251 11.9037 10.4831 11.6896 10.3013C11.5738 10.2031 11.4527 10.1114 11.3268 10.0265C11.2434 9.96809 11.1518 9.90963 11.0352 9.83421C10.0126 9.16778 7.97918 9.20461 7.9121 9.20636H7.90568C7.34978 8.50076 7.38886 6.17348 7.42036 5.68769C7.41395 5.65729 7.00621 5.89989 6.95371 5.93672C6.46318 6.28743 6.00465 6.68104 5.58351 7.11293C5.10426 7.59988 4.66642 8.12609 4.27455 8.68607C3.37298 9.96657 2.7336 11.4134 2.39336 12.9431C2.38228 12.97 1.88354 15.1523 2.1297 16.284Z"
            fill="url(#paint7_radial_87_7118)"
          ></path>{" "}
          <path
            d="M20.9634 10.7399C21.4752 11.2431 21.9135 11.8162 22.2653 12.4423C22.3383 12.4971 22.4083 12.5557 22.4753 12.6176C25.6532 15.55 23.9908 19.7012 23.8642 19.9993C26.446 17.8673 28.0973 14.7146 27.6003 11.4601C26.0155 7.49777 23.3276 5.90065 21.1325 2.42407C21.0211 2.24869 20.9103 2.07331 20.8018 1.88566C20.7406 1.77985 20.691 1.68397 20.6478 1.59336C20.5569 1.41757 20.4866 1.23179 20.4384 1.03975C20.4388 1.03063 20.4358 1.02169 20.43 1.01467C20.4241 1.00765 20.4159 1.00305 20.4069 1.00175C20.3983 0.999416 20.3893 0.999416 20.3807 1.00175C20.3783 1.00281 20.3762 1.00419 20.3742 1.00584C20.3707 1.00584 20.3672 1.00994 20.3637 1.0111C19.8213 1.27066 16.606 6.37301 20.9634 10.7399Z"
            fill="url(#paint8_radial_87_7118)"
          ></path>{" "}
          <path
            d="M22.4743 12.6146C22.4073 12.5526 22.3372 12.4941 22.2643 12.4392C22.2357 12.4176 22.206 12.396 22.1768 12.3743C21.4284 11.8482 20.088 11.3267 18.7971 11.5518C23.8393 14.0784 22.4854 22.7795 15.4985 22.451C14.8764 22.426 14.2616 22.3078 13.6744 22.1002C13.5374 22.0488 13.3997 21.9921 13.2626 21.9313C13.1833 21.895 13.1045 21.8588 13.0293 21.8185L13.0386 21.8243C14.0133 22.4908 18.8274 24.1194 23.8585 20.0121C23.8585 20.0121 23.8614 20.0045 23.8661 19.9939C23.9909 19.7011 25.6534 15.5499 22.4743 12.6146Z"
            fill="url(#paint9_radial_87_7118)"
          ></path>{" "}
          <path
            d="M9.72532 17.2215C9.72532 17.2215 10.3722 14.8048 14.3586 14.8048C14.7897 14.8048 16.0216 13.5994 16.0444 13.2498C16.0671 12.9002 13.4953 14.3231 10.7811 13.0428C7.85055 11.6608 5.62695 13.2498 5.62695 13.2498C5.62695 13.2498 6.47159 15.3438 8.94776 15.3438C8.68819 17.6407 9.89973 20.3187 12.8332 21.7241C12.8986 21.755 12.9604 21.7895 13.0275 21.8199C11.3154 20.9349 9.90207 19.2571 9.72532 17.2215Z"
            fill="url(#paint10_radial_87_7118)"
          ></path>{" "}
          <path
            d="M28.9905 10.7265C28.3816 9.2574 27.1473 7.67139 26.1784 7.17039C26.967 8.72015 27.4232 10.2746 27.5976 11.4344C27.5976 11.4344 27.5976 11.4426 27.6005 11.4578C26.0156 7.49777 23.3277 5.90065 21.1327 2.42407C21.0213 2.24869 20.9105 2.07331 20.802 1.88566C20.7407 1.77985 20.6911 1.68397 20.648 1.59336C20.557 1.41757 20.4867 1.23179 20.4386 1.03975C20.439 1.03063 20.4359 1.02169 20.4301 1.01467C20.4243 1.00765 20.4161 1.00305 20.4071 1.00175C20.3985 0.999416 20.3894 0.999416 20.3808 1.00175C20.3785 1.00281 20.3763 1.00419 20.3744 1.00584C20.3709 1.00584 20.3674 1.00994 20.3639 1.0111L20.3697 1.0035C16.8483 3.07063 15.6536 6.89446 15.544 8.80784C15.7073 8.79673 15.8701 8.78271 16.0363 8.78271C18.6641 8.78271 20.9531 10.2313 22.1786 12.3774C21.4302 11.8512 20.0898 11.3298 18.7989 11.5549C23.841 14.0815 22.4872 22.7826 15.5002 22.454C14.8782 22.429 14.2633 22.3108 13.6762 22.1033C13.5391 22.0518 13.4015 21.9951 13.2644 21.9343C13.1851 21.8981 13.1063 21.8618 13.0311 21.8215L13.0404 21.8273C12.9727 21.7946 12.9045 21.7607 12.8368 21.7256C12.9021 21.7566 12.964 21.7911 13.0311 21.8215C11.3155 20.9347 9.90216 19.2569 9.72542 17.2213C9.72542 17.2213 10.3723 14.8046 14.3587 14.8046C14.7898 14.8046 16.0217 13.5992 16.0445 13.2496C16.0392 13.1356 13.5998 12.1628 12.6484 11.2234C12.1403 10.7218 11.8988 10.4798 11.6848 10.298C11.5689 10.1998 11.4478 10.1081 11.3219 10.0232C11.0026 8.9027 10.9891 7.71683 11.2829 6.58931C9.84266 7.24697 8.7227 8.28463 7.90839 9.20303H7.90198C7.34608 8.49742 7.38516 6.17015 7.41666 5.68435C7.41024 5.65395 7.00251 5.89656 6.95001 5.93339C6.45948 6.2841 6.00095 6.67771 5.5798 7.1096C5.10055 7.59655 4.66271 8.12276 4.27084 8.68274C3.36927 9.96323 2.72989 11.4101 2.38965 12.9398C2.38324 12.9702 2.3774 13.0017 2.37099 13.0327C2.34474 13.1561 2.22574 13.7839 2.20941 13.9184C2.20941 13.9289 2.20941 13.9084 2.20941 13.9184C2.10019 14.5671 2.03026 15.2219 2 15.8791V15.951C2 23.7097 8.27646 30 16.0182 30C22.9521 30 28.7088 24.9549 29.8364 18.328C29.8597 18.1485 29.8789 17.9673 29.8999 17.786C30.1788 15.3763 29.869 12.8439 28.9905 10.7265ZM27.5999 11.4479V11.4631V11.4479Z"
            fill="url(#paint11_linear_87_7118)"
          ></path>{" "}
          <defs>
            {" "}
            <linearGradient
              id="paint0_linear_87_7118"
              x1="27.135"
              y1="5.49261"
              x2="3.81392"
              y2="27.9437"
              gradientUnits="userSpaceOnUse"
            >
              {" "}
              <stop offset="0.05" stop-color="#FFF44F"></stop>{" "}
              <stop offset="0.11" stop-color="#FFE847"></stop>{" "}
              <stop offset="0.22" stop-color="#FFC830"></stop>{" "}
              <stop offset="0.37" stop-color="#FF980E"></stop>{" "}
              <stop offset="0.4" stop-color="#FF8B16"></stop>{" "}
              <stop offset="0.46" stop-color="#FF672A"></stop>{" "}
              <stop offset="0.53" stop-color="#FF3647"></stop>{" "}
              <stop offset="0.7" stop-color="#E31587"></stop>{" "}
            </linearGradient>{" "}
            <radialGradient
              id="paint1_radial_87_7118"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(26.0596 4.21879) scale(29.2246 29.2888)"
            >
              {" "}
              <stop offset="0.13" stop-color="#FFBD4F"></stop>{" "}
              <stop offset="0.19" stop-color="#FFAC31"></stop>{" "}
              <stop offset="0.25" stop-color="#FF9D17"></stop>{" "}
              <stop offset="0.28" stop-color="#FF980E"></stop>{" "}
              <stop offset="0.4" stop-color="#FF563B"></stop>{" "}
              <stop offset="0.47" stop-color="#FF3750"></stop>{" "}
              <stop offset="0.71" stop-color="#F5156C"></stop>{" "}
              <stop offset="0.78" stop-color="#EB0878"></stop>{" "}
              <stop offset="0.86" stop-color="#E50080"></stop>{" "}
            </radialGradient>{" "}
            <radialGradient
              id="paint2_radial_87_7118"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(15.3809 16.1925) scale(29.2246 29.2888)"
            >
              {" "}
              <stop offset="0.3" stop-color="#960E18"></stop>{" "}
              <stop
                offset="0.35"
                stop-color="#B11927"
                stop-opacity="0.74"
              ></stop>{" "}
              <stop
                offset="0.43"
                stop-color="#DB293D"
                stop-opacity="0.34"
              ></stop>{" "}
              <stop
                offset="0.5"
                stop-color="#F5334B"
                stop-opacity="0.09"
              ></stop>{" "}
              <stop
                offset="0.53"
                stop-color="#FF3750"
                stop-opacity="0"
              ></stop>{" "}
            </radialGradient>{" "}
            <radialGradient
              id="paint3_radial_87_7118"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(18.904 -2.42815) scale(21.172 21.2184)"
            >
              {" "}
              <stop offset="0.13" stop-color="#FFF44F"></stop>{" "}
              <stop offset="0.25" stop-color="#FFDC3E"></stop>{" "}
              <stop offset="0.51" stop-color="#FF9D12"></stop>{" "}
              <stop offset="0.53" stop-color="#FF980E"></stop>{" "}
            </radialGradient>{" "}
            <radialGradient
              id="paint4_radial_87_7118"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(12.1487 23.8433) scale(13.915 13.9455)"
            >
              {" "}
              <stop offset="0.35" stop-color="#3A8EE6"></stop>{" "}
              <stop offset="0.47" stop-color="#5C79F0"></stop>{" "}
              <stop offset="0.67" stop-color="#9059FF"></stop>{" "}
              <stop offset="1" stop-color="#C139E6"></stop>{" "}
            </radialGradient>{" "}
            <radialGradient
              id="paint5_radial_87_7118"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(15.8005 12.7119) rotate(-13.9265) scale(7.37316 8.67852)"
            >
              {" "}
              <stop
                offset="0.21"
                stop-color="#9059FF"
                stop-opacity="0"
              ></stop>{" "}
              <stop
                offset="0.28"
                stop-color="#8C4FF3"
                stop-opacity="0.06"
              ></stop>{" "}
              <stop
                offset="0.75"
                stop-color="#7716A8"
                stop-opacity="0.45"
              ></stop>{" "}
              <stop
                offset="0.97"
                stop-color="#6E008B"
                stop-opacity="0.6"
              ></stop>{" "}
            </radialGradient>{" "}
            <radialGradient
              id="paint6_radial_87_7118"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(15.011 3.02041) scale(10.0108 10.0328)"
            >
              {" "}
              <stop stop-color="#FFE226"></stop>{" "}
              <stop offset="0.12" stop-color="#FFDB27"></stop>{" "}
              <stop offset="0.3" stop-color="#FFC82A"></stop>{" "}
              <stop offset="0.5" stop-color="#FFA930"></stop>{" "}
              <stop offset="0.73" stop-color="#FF7E37"></stop>{" "}
              <stop offset="0.79" stop-color="#FF7139"></stop>{" "}
            </radialGradient>{" "}
            <radialGradient
              id="paint7_radial_87_7118"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(22.8805 -3.34313) scale(42.7109 42.8046)"
            >
              {" "}
              <stop offset="0.11" stop-color="#FFF44F"></stop>{" "}
              <stop offset="0.46" stop-color="#FF980E"></stop>{" "}
              <stop offset="0.62" stop-color="#FF5634"></stop>{" "}
              <stop offset="0.72" stop-color="#FF3647"></stop>{" "}
              <stop offset="0.9" stop-color="#E31587"></stop>{" "}
            </radialGradient>{" "}
            <radialGradient
              id="paint8_radial_87_7118"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(18.7517 1.33374) rotate(84.2447) scale(31.1996 20.4543)"
            >
              {" "}
              <stop stop-color="#FFF44F"></stop>{" "}
              <stop offset="0.06" stop-color="#FFE847"></stop>{" "}
              <stop offset="0.17" stop-color="#FFC830"></stop>{" "}
              <stop offset="0.3" stop-color="#FF980E"></stop>{" "}
              <stop offset="0.36" stop-color="#FF8B16"></stop>{" "}
              <stop offset="0.45" stop-color="#FF672A"></stop>{" "}
              <stop offset="0.57" stop-color="#FF3647"></stop>{" "}
              <stop offset="0.74" stop-color="#E31587"></stop>{" "}
            </radialGradient>{" "}
            <radialGradient
              id="paint9_radial_87_7118"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(14.7757 6.73593) scale(26.6644 26.723)"
            >
              {" "}
              <stop offset="0.14" stop-color="#FFF44F"></stop>{" "}
              <stop offset="0.48" stop-color="#FF980E"></stop>{" "}
              <stop offset="0.59" stop-color="#FF5634"></stop>{" "}
              <stop offset="0.66" stop-color="#FF3647"></stop>{" "}
              <stop offset="0.9" stop-color="#E31587"></stop>{" "}
            </radialGradient>{" "}
            <radialGradient
              id="paint10_radial_87_7118"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(21.8145 8.30059) scale(29.1844 29.2484)"
            >
              {" "}
              <stop offset="0.09" stop-color="#FFF44F"></stop>{" "}
              <stop offset="0.23" stop-color="#FFE141"></stop>{" "}
              <stop offset="0.51" stop-color="#FFAF1E"></stop>{" "}
              <stop offset="0.63" stop-color="#FF980E"></stop>{" "}
            </radialGradient>{" "}
            <linearGradient
              id="paint11_linear_87_7118"
              x1="26.855"
              y1="5.37218"
              x2="7.01043"
              y2="25.1739"
              gradientUnits="userSpaceOnUse"
            >
              {" "}
              <stop
                offset="0.17"
                stop-color="#FFF44F"
                stop-opacity="0.8"
              ></stop>{" "}
              <stop
                offset="0.27"
                stop-color="#FFF44F"
                stop-opacity="0.63"
              ></stop>{" "}
              <stop
                offset="0.49"
                stop-color="#FFF44F"
                stop-opacity="0.22"
              ></stop>{" "}
              <stop
                offset="0.6"
                stop-color="#FFF44F"
                stop-opacity="0"
              ></stop>{" "}
            </linearGradient>{" "}
          </defs>{" "}
        </g>
      </svg>
    );
  }
  // Chrome
  return (
    <svg
      viewBox="0 0 32 32"
      data-name="Layer 1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={`shrink-0 ${className}`}
      aria-hidden="true"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M4.7434,22.505A12.9769,12.9769,0,0,0,14.88,28.949l5.8848-10.1927L16,16.0058,11.2385,18.755l-1.5875-2.75L8.4885,13.9919,5.3553,8.5649A12.9894,12.9894,0,0,0,4.7434,22.505Z"
          fill="#00ac47"
        ></path>
        <path
          d="M16,3.0072A12.9769,12.9769,0,0,0,5.3507,8.5636l5.8848,10.1927L16,16.0057V10.5072H27.766A12.99,12.99,0,0,0,16,3.0072Z"
          fill="#ea4435"
        ></path>
        <path
          d="M27.2557,22.505a12.9772,12.9772,0,0,0,.5124-12H15.9986v5.5011l4.7619,2.7492-1.5875,2.75-1.1625,2.0135-3.1333,5.4269A12.99,12.99,0,0,0,27.2557,22.505Z"
          fill="#ffba00"
        ></path>
        <circle cx="15.9995" cy="16.0072" fill="#ffffff" r="5.5"></circle>
        <circle cx="15.9995" cy="16.0072" fill="#4285f4" r="4.25"></circle>
      </g>
    </svg>
  );
}
